import { Suspense } from 'react'

const messages = [
  "Teaching pixels to behave... they're being stubborn today",
  'Downloading inspiration from the cloud... 67% creative, 33% caffeine',
  'Assembling your digital playground... some assembly required (batteries not included)',
  'Convincing the code fairies to organize your project... they demand pizza',
  'Loading your game world... please wait while we negotiate with the physics engine',
  'Calibrating fun levels... current reading: maximum overdrive',
  "Waking up the sprite sprites... they're not morning people",
  'Compiling dreams into reality... 404 bugs not found (we hope)',
  'Initializing creative chaos... organized mess loading at 88%',
  "Summoning the game dev gods... they're stuck in traffic, please hold",
]

const PageLoader = ({ children }: { children: React.ReactNode }) => {
  const getRandomLoadingMessage = () => {
    const randomIndex = Math.floor(Math.random() * messages.length)
    return messages[randomIndex]
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-dvh w-dvw flex-col items-center justify-center">
          <img src="/logo.png" className="size-12 animate-pulse" alt="Logo" />
          <p className="mx-4 mt-4 max-w-6xl text-center text-sm font-bold text-white">
            {getRandomLoadingMessage()}
          </p>
        </div>
      }
    >
      {children}
    </Suspense>
  )
}

export default PageLoader
